export class Usuario {
    idUsuario: string;
    usuario: string;
    contrasenia: string;
}